import Angular from "angular";
import Template from "./wheel-storage-item.html";

export default Angular.module('wheel-storage-item', [])
    .component('wheelStorageItem', {
        template: Template,
        bindings: {
            wheelStorage: '<',
            iconRight: '@'
        }
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/wheel-storage-item/wheel-storage-item.js